import React from "react";
import Header from "../../shared/Header/Header";
import MechatronicsSection from "./MechatronicsSection/MechatronicsSection";
import AuthorisedChannelPartner from "./AuthorisedChannelPartner/AuthorisedChannelPartner";
import AuthorisedServiceCentre from "./AuthorisedServiceCentre/AuthorisedServiceCentre";
import IndustrialSolutions from "./IndustrialSolutions/IndustrialSolutions";
import PlasticMoulding from "./PlasticMoulding/PlasticMoulding";
import Footer from "../../shared/Footer/Footer";
import styles from "./Product.module.css";

const Product = () => {
  return (
    <div className={styles.page}>
      <Header />
       <main>
         <MechatronicsSection />
         <AuthorisedChannelPartner />
         <AuthorisedServiceCentre />
         <IndustrialSolutions />
         <PlasticMoulding />
      </main>
      <Footer />
    </div>
  );
};

export default Product;
